import { Component, input, InputSignal, OnInit } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

import { CustomValidators } from '@shared/functions/validators';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatError, MatHint } from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'z-input',
    templateUrl: './z-input.component.html',
    styleUrls: ['./z-input.component.scss'],
    imports: [MatFormField, MatLabel, MatInput, ReactiveFormsModule, NgxMaskDirective, MatIconButton, MatSuffix, MatIcon, MatError, MatHint, TranslatePipe]
})
export class ZInputComponent implements OnInit {
    readonly label = input<string>('');
    readonly placeholder = input<string>('');
    readonly formControlRef = input<FormControl>(new FormControl());
    readonly email = input<boolean>(false);
    readonly mask = input<string>('');
    readonly prefix = input<string>('');
    readonly icon = input<string>('');
    readonly required = input<boolean>(false);
    readonly id = input<string>('');
    readonly type = input<string>('text');
    readonly hint = input<string>('');
    readonly autocomplete = input<string>('off');

    readonly appearance =
        input<MatFormFieldAppearance>('outline');
    readonly dropSpecialCharacters = input<boolean>(true);
    // Força maiúsculas (ex.: CNPJ alfanumérico, cujas letras são sempre maiúsculas).
    readonly uppercase = input<boolean>(false);
    // Aplica validação de CNPJ (dígito verificador) → marca o campo como inválido.
    readonly validateCnpj = input<boolean>(false);

    onInput(event: Event): void {
        if (!this.uppercase()) return;
        const target = event.target as HTMLInputElement;
        const upper = target.value.toUpperCase();
        if (target.value !== upper) {
            target.value = upper;
            this.formControlRef().setValue(upper);
        }
    }

    ngOnInit(): void {
        const formControl = this.formControlRef();
        if (this.email() && formControl) {
            formControl.addValidators([CustomValidators.email]);
            formControl.updateValueAndValidity();
        }
        if (this.validateCnpj() && formControl) {
            formControl.addValidators([CustomValidators.cnpj]);
            formControl.updateValueAndValidity();
        }
    }
}
